import React from "react";
import { UserDropDownSentinel } from "./UserDropDownSentinel";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction } from "react-router-dom";
import { SiteDropDownSentinel } from "./SiteDropDownSentinel";
import { CameraDropDownSentinel } from "./CameraDropDownSentinel";
import { StartDateDropDownSentinel } from "./StartDateDropDownSentinel";
import { EndDateDropDownSentinel } from "./EndDateDropDownSentinel";
import { ApplyFiltersButtonSentinel } from "./ApplyFiltersButtonSentinel";
import { StartTimeDropDownSentinel } from "./StartTimeDropDownSentinel";
import { EndTimeDropDownSentinel } from "./EndTimeDropDownSentinel";
import { ClipResultDropDown } from "./ClipResultDropDown";
import { useClipsStore } from "./ClipsStore/clipsStore";

export const SentinelFilters = ({
  showUserDropDownSentinel,
  userDropDownValueSentinel,
  userOptions,
  setUserDropDownValueSentinel,
  setCameraDropDownValueSentinel,
  setUserFiltersSentinel,
  setSiteDropDownValueSentinel,
  setSiteOptionsSentinel,
  setCameraOptionsSentinel,
  setLoadingSitesSentinel,
  siteOptionsSentinel,
  loadingSitesSentinel,
  siteDropDownValueSentinel,
  setLoadingCamerasSentinel,
  cameraOptionsSentinel,
  cameraDropDownValueSentinel,
  loadingCamerasSentinel,
  userFiltersSentinel,
  setSentinelData,
  setPageLoadingSentinel,
  setSelectedRowSentinel,
  setPrecisionRecallDataSentinel,
  setVideoURLSentinel,
  setVideoClipLoadingSentinel,
  setClipsIndexOrderSentinel,
  selectedRowSentinel,
  setNoDataToDisplaySentinel,
  setFetchingFilteredDataSentinel,
  setPageSentinel,
  onSentinelFiltersApply,
  setLoadingAdditionalData,
  navBarCollapsed,
  setFiltersApplied,
  userInfo,
  timeFiltersDisabledSentinel,
  setTimeFiltersDisabledSentinel,
  navigate,
  setSearchParams,
}: {
  showUserDropDownSentinel: boolean;
  userDropDownValueSentinel: any;
  userOptions: any;
  setUserDropDownValueSentinel: any;
  setCameraDropDownValueSentinel: any;
  setUserFiltersSentinel: any;
  setSiteDropDownValueSentinel: any;
  setSiteOptionsSentinel: any;
  setCameraOptionsSentinel: any;
  setLoadingSitesSentinel: Dispatcher<boolean>;
  siteOptionsSentinel: any;
  loadingSitesSentinel: boolean;
  siteDropDownValueSentinel: string | null;
  setLoadingCamerasSentinel: Dispatcher<boolean>;
  cameraOptionsSentinel: any;
  cameraDropDownValueSentinel: string | null;
  loadingCamerasSentinel: boolean;
  userFiltersSentinel: any;
  setSentinelData: any;
  setPageLoadingSentinel: Dispatcher<boolean>;
  setSelectedRowSentinel: any;
  setPrecisionRecallDataSentinel: any;
  setVideoURLSentinel: any;
  setVideoClipLoadingSentinel: Dispatcher<boolean>;
  setClipsIndexOrderSentinel: any;
  selectedRowSentinel: any;
  setNoDataToDisplaySentinel: Dispatcher<boolean>;
  setFetchingFilteredDataSentinel: Dispatcher<boolean>;
  setPageSentinel: any;
  onSentinelFiltersApply?: () => void;
  setLoadingAdditionalData: Dispatcher<boolean>;
  navBarCollapsed: boolean;
  setFiltersApplied: Dispatcher<boolean>;
  userInfo: any;
  timeFiltersDisabledSentinel: boolean;
  setTimeFiltersDisabledSentinel: Dispatcher<boolean>;
  navigate: NavigateFunction;
  setSearchParams?: (params: URLSearchParams) => void;
}) => {
  const { getDownloadURLSentinel } = useClipsStore();

  // Prefetch the report download URL from filter STATE rather than from
  // dropdown onChange handlers, so every path that sets filters is covered —
  // including URL-param hydration and drill-down navigation, which never
  // touch the dropdowns (PROD-47: camera-level drill-down had no report URL).
  React.useEffect(() => {
    if (!userFiltersSentinel?.user) return;
    getDownloadURLSentinel(navigate, userFiltersSentinel);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userFiltersSentinel]);

  let noUserDropDownCSS = showUserDropDownSentinel
    ? [
        "absolute top-0 left-[160px]",
        "absolute top-0 left-[320px]",
        "absolute top-0 left-[480px]",
        "absolute top-0 left-[640px]",
        "absolute top-0 left-[800px]",
        "absolute top-0 left-[944px]",
        "absolute top-0 left-[1088px]",
        "absolute top-0",
        "absolute top-[8px] left-[1228px]",
      ]
    : [
        "absolute top-0",
        "absolute top-0 left-[210px]",
        "absolute top-0 left-[420px]",
        "absolute top-0 left-[580px]",
        "absolute top-0 left-[740px]",
        "absolute top-0 left-[882px]",
        "absolute top-0 left-[1024px]",
        "absolute top-[8px] left-[1164px]",
      ];

  if (showUserDropDownSentinel && navBarCollapsed) {
    noUserDropDownCSS = [
      "absolute top-0 left-[185px]",
      "absolute top-0 left-[370px]",
      "absolute top-0 left-[555px]",
      "absolute top-0 left-[715px]",
      "absolute top-0 left-[875px]",
      "absolute top-0 left-[1012px]",
      "absolute top-0 left-[1154px]",
      "absolute top-0",
      "absolute top-[8px] left-[1294px]",
    ];
  }

  if (!showUserDropDownSentinel && navBarCollapsed) {
    noUserDropDownCSS = [
      "absolute top-0",
      "absolute top-0 left-[250px]",
      "absolute top-0 left-[495px]",
      "absolute top-0 left-[655px]",
      "absolute top-0 left-[815px]",
      "absolute top-0 left-[957px]",
      "absolute top-0 left-[1099px]",
      "absolute top-[8px] left-[1240px]",
    ];
  }
  return (
    <div
      className={
        userInfo.permission.sentinel &&
        (userInfo.permission.ailink || userInfo.permission.smtp)
          ? "absolute top-[60px] left-0"
          : "absolute top-[0px] left-0"
      }
    >
      {showUserDropDownSentinel && (
        <div className={noUserDropDownCSS[7]}>
          <UserDropDownSentinel
            userDropDownValueSentinel={userDropDownValueSentinel}
            userOptions={userOptions}
            setUserDropDownValueSentinel={setUserDropDownValueSentinel}
            setCameraDropDownValueSentinel={setCameraDropDownValueSentinel}
            setUserFiltersSentinel={setUserFiltersSentinel}
            setSiteDropDownValueSentinel={setSiteDropDownValueSentinel}
            setSiteOptionsSentinel={setSiteOptionsSentinel}
            setCameraOptionsSentinel={setCameraOptionsSentinel}
            setLoadingSitesSentinel={setLoadingSitesSentinel}
            navBarCollapsed={navBarCollapsed}
            navigate={navigate}
          />
        </div>
      )}
      <div className={noUserDropDownCSS[0]}>
        <SiteDropDownSentinel
          siteOptionsSentinel={siteOptionsSentinel}
          loadingSitesSentinel={loadingSitesSentinel}
          siteDropDownValueSentinel={siteDropDownValueSentinel}
          setSiteDropDownValueSentinel={setSiteDropDownValueSentinel}
          setCameraDropDownValueSentinel={setCameraDropDownValueSentinel}
          setUserFiltersSentinel={setUserFiltersSentinel}
          setCameraOptionsSentinel={setCameraOptionsSentinel}
          setLoadingCamerasSentinel={setLoadingCamerasSentinel}
          showUserDropDown={showUserDropDownSentinel}
          navBarCollapsed={navBarCollapsed}
          navigate={navigate}
        />
      </div>
      <div className={noUserDropDownCSS[1]}>
        <CameraDropDownSentinel
          setUserFiltersSentinel={setUserFiltersSentinel}
          cameraOptionsSentinel={cameraOptionsSentinel}
          cameraDropDownValueSentinel={cameraDropDownValueSentinel}
          setCameraDropDownValueSentinel={setCameraDropDownValueSentinel}
          siteOptionsSentinel={siteOptionsSentinel}
          loadingCamerasSentinel={loadingCamerasSentinel}
          navBarCollapsed={navBarCollapsed}
          showUserDropDown={showUserDropDownSentinel}
        />
      </div>
      <div className={noUserDropDownCSS[2]}>
        <StartDateDropDownSentinel
          userFiltersSentinel={userFiltersSentinel}
          setUserFiltersSentinel={setUserFiltersSentinel}
          setTimeFiltersDisabledSentinel={setTimeFiltersDisabledSentinel}
        />
      </div>
      <div className={noUserDropDownCSS[3]}>
        <EndDateDropDownSentinel
          userFiltersSentinel={userFiltersSentinel}
          setUserFiltersSentinel={setUserFiltersSentinel}
          setTimeFiltersDisabledSentinel={setTimeFiltersDisabledSentinel}
        />
      </div>
      <div className={noUserDropDownCSS[4]}>
        <StartTimeDropDownSentinel
          userFiltersSentinel={userFiltersSentinel}
          setUserFiltersSentinel={setUserFiltersSentinel}
          timeFiltersDisabledSentinel={timeFiltersDisabledSentinel}
          showUserDropDownSentinel={showUserDropDownSentinel}
        />
      </div>
      <div className={noUserDropDownCSS[5]}>
        <EndTimeDropDownSentinel
          userFiltersSentinel={userFiltersSentinel}
          setUserFiltersSentinel={setUserFiltersSentinel}
          timeFiltersDisabledSentinel={timeFiltersDisabledSentinel}
          showUserDropDownSentinel={showUserDropDownSentinel}
        />
      </div>
      <div className={noUserDropDownCSS[6]}>
        <ClipResultDropDown
          userFilters={userFiltersSentinel}
          setUserFilters={setUserFiltersSentinel}
          showUserDropDown={showUserDropDownSentinel}
        />
      </div>
      <div
        className={
          noUserDropDownCSS[showUserDropDownSentinel ? 8 : 7]
        }
      >
        <ApplyFiltersButtonSentinel
          setSentinelData={setSentinelData}
          setPageLoadingSentinel={setPageLoadingSentinel}
          setSelectedRowSentinel={setSelectedRowSentinel}
          setPrecisionRecallDataSentinel={setPrecisionRecallDataSentinel}
          setVideoURLSentinel={setVideoURLSentinel}
          setVideoClipLoadingSentinel={setVideoClipLoadingSentinel}
          setClipsIndexOrderSentinel={setClipsIndexOrderSentinel}
          selectedRowSentinel={selectedRowSentinel}
          setNoDataToDisplaySentinel={setNoDataToDisplaySentinel}
          setSiteOptionsSentinel={setSiteOptionsSentinel}
          setLoadingSitesSentinel={setLoadingSitesSentinel}
          userFiltersSentinel={userFiltersSentinel}
          setFetchingFilteredDataSentinel={setFetchingFilteredDataSentinel}
          setPageSentinel={setPageSentinel}
          onSentinelFiltersApply={onSentinelFiltersApply}
          setLoadingAdditionalData={setLoadingAdditionalData}
          setFiltersApplied={setFiltersApplied}
          navigate={navigate}
          setSearchParams={setSearchParams}
        />
      </div>
    </div>
  );
};
